<template>
	<tr :class="[{'disable-allocation-row':monthlyAllocation.nonallocatedMonth},isClosed]">
		<td class="right-td mh-days">
			<p class="right-td">{{monthlyAllocation.totalWorkingDays}}</p>
		</td>
		<td class="right-td mh-vac">
			<input
				class="table-input-x"
				:class="{'error-border':errors.vacation}"
				v-model="vacation"
				:disabled="monthlyAllocation.nonallocatedMonth"
				@keyup="submitAllocation"
			/>
		</td>
    
		<td class="right-td mh-sick">
			<input
				class="table-input-x"
				:class="{'error-border':errors.sick}"
				v-model="sick"
				:disabled="monthlyAllocation.nonallocatedMonth"
				@keyup="submitAllocation"
			/>
		</td>
		<td class="right-td mh-other">
			<input
				class="table-input-x"
				:class="{'error-border':errors.other}"
				v-model="other"
				:disabled="monthlyAllocation.nonallocatedMonth"
				@keyup="submitAllocation"
			/>
		</td>
    <td class="right-td mh-not-yet-approved-holiday">
			<input
				class="table-input-x"
				:class="{'error-border':errors.notYetApprovedHoliday}"
				v-model="notYetApprovedHoliday"
				:disabled="monthlyAllocation.nonallocatedMonth"
				@keyup="submitAllocation"
			/>
		</td>
		<td class="right-td note-t mh-act">
			<p class="right-td">{{actualWorkingDays}}</p>
		</td>

		<td class="right-td mh-note">
			<p class="right-td">
				<a
					@click.stop.prevent="showNote"
					class="note-elem"
					:class="hasNote?'comments-active':'comments'"
				/>
			</p>
		</td>
		<td class="right-td tv">
			<p v-if="monthlyAllocation.nonallocatedMonth" class="right-td">-</p>
			<p v-else class="right-td">
				<i
					v-tooltip.top-start="`${$options.filters.money(turnOver)} €`"
				>{{turnOver | money | truncate(9)}} €</i>
			</p>
		</td>
	</tr>
</template>

<script>
import _ from "lodash";
import filters from "../../../../mixins/filters";

export default {
  name: "AllocationMonth",
  props: ["monthlyAllocation", "index", "allocationIndex"],
  mixins: [filters],
  data: () => {
    return {
      typingTimer: 0,
      vacation: 0,
      sick: 0,
      other: 0,
      notYetApprovedHoliday:0,
      errors: {
        vacation: false,
        sick: false,
        other: false,
        notYetApprovedHoliday:false
      }
    };
  },
  computed: {
    /**
     * Find the actual working days
     * @returns {number}
     */
    actualWorkingDays: function() {
      // actual working days = total working days - leave days
      let monthlyAllocation = _.cloneDeep(this.monthlyAllocation);
      return (
        parseFloat(monthlyAllocation.totalWorkingDays) -
        (parseFloat(monthlyAllocation.totalVacation) +
          parseFloat(monthlyAllocation.totalSick) +
          parseFloat(this.monthlyAllocation.other) + parseFloat(this.monthlyAllocation.notYetApprovedHoliday))
      );
    },
    /**
     * Get all relations
     * @returns {[]|ReadonlyArray<any>|*}
     */
    relations: function() {
      return this.$store.state.forecast.users;
    },
    /**
     * Get the current row of relation
     * @returns {*}
     */
    relation: function() {
      return this.relations.find(
        r => r.employeeProjectReleationId === this.monthlyAllocation.relationId
      );
    },
    /**
     * Calculate the turnover
     * @returns {number}
     */
    turnOver: function() {
      // get the relation
      let relation = this.relation;
      // calculate the engagement per day in hour
      let userEngagementPerDay =
        parseFloat(
          (parseFloat(relation.qEmployment) / 100) *
            relation.workingHoursCountryBased
        ) *
        (parseFloat(relation.projectEngagement) / 100);
      // calculate the user turnover per day
      let userTurnoverPerDay =
        parseFloat(relation.hourlyRate) * userEngagementPerDay;
      // calculate the monthly turn over
      let turnOver = this.actualWorkingDays * userTurnoverPerDay;
      // return 0 if NaN
      return isNaN(turnOver) ? 0 : turnOver;
    },
    hasNote: function() {
      return !!this.monthlyAllocation.note;
    },
    isClosed:function(){
      if(this.monthlyAllocation.isClosed===true)
        return "closed-project-row"
      else
      return"open-project-row"
    }
  },
  methods: {
    /**
     * Submit allocations for the user
     */
    submitAllocation: function() {
      // clear the timeout value
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        // if all the fields are valid
        if (this.validate()) {
          // get the clone of monthly allocation
          let monthlyAllocation = _.cloneDeep(this.monthlyAllocation);
          // update the field values
          monthlyAllocation.totalVacation = this.vacation;
          monthlyAllocation.totalSick = this.sick;
          monthlyAllocation.other = this.other;
          monthlyAllocation.notYetApprovedHoliday=this.notYetApprovedHoliday;
          // generate the data object
          let data = {
            id: this.index,
            allocationIndex: this.allocationIndex,
            value: monthlyAllocation
          };
          // submit the data
          this.$store.dispatch("updateAllocation", data);
        }
      }, 500);
    },
    /**
     * Validate the leave input fields
     * Values must be number or decimal point
     * @returns {boolean}
     */
    validate: function() {
      // init all validation values
      let isValid = true;
      this.errors = {
        vacation: false,
        sick: false,
        other: false,
        notYetApprovedHoliday:false 
      };
      // reqex to check if number
      let RE = /^\d+(\.5)?$/;
      // check validations for all values
      // check if value is a number
      // check if the value is more than the total working days
      // check if the entered value is less than zero
      if (
        !RE.test(this.vacation) ||
        this.vacation > this.monthlyAllocation.totalWorkingDays ||
        this.vacation < 0
      ) {
        this.errors.vacation = true;
        isValid = false;
      }
      if (
        !RE.test(this.sick) ||
        this.sick > this.monthlyAllocation.totalWorkingDays ||
        this.sick < 0
      ) {
        this.errors.sick = true;
        isValid = false;
      }
      if (
        !RE.test(this.other) ||
        this.other > this.monthlyAllocation.totalWorkingDays ||
        this.other < 0
      ) {
        this.errors.other = true;
        isValid = false;
      }
      if (
        !RE.test(this.notYetApprovedHoliday) ||
        this.notYetApprovedHoliday > this.monthlyAllocation.totalWorkingDays ||
        this.notYetApprovedHoliday < 0
      ) {
        this.errors.notYetApprovedHoliday = true;
        isValid = false;
      }
      // if all the above validations are true
      if (isValid) {
        // get the actual working days of the user
        let actualWorkingDays =
          parseFloat(this.monthlyAllocation.totalWorkingDays) -
          (parseFloat(this.vacation) +
            parseFloat(this.sick) +
            parseFloat(this.other)+parseFloat(this.notYetApprovedHoliday));
        // check if the actual working days is a number and less than zero
        if (!RE.test(actualWorkingDays) || actualWorkingDays < 0) {
          this.errors.vacation = true;
          this.errors.sick = true;
          this.errors.other = true;
          this.errors.notYetApprovedHoliday = true;
          isValid = false;
        }
      }
      // return the validation status value
      return isValid;
    },
    /**
     * Open the popup for showing the note
     */
    showNote: function() {
      let data = {
        relation: this.relation,
        allocationIndex: this.allocationIndex,
        index: this.index,
        monthlyAllocation: this.monthlyAllocation
      };
      this.$store.commit("setNotePopUpData", data);
      this.$store.commit("setNotePopUpFlag", true);
    }
  },
  watch: {
    monthlyAllocation: {
      handler: function() {
        // set initial values
        this.vacation = this.monthlyAllocation.totalVacation || 0;
        this.sick = this.monthlyAllocation.totalSick || 0;
        this.other = this.monthlyAllocation.other || 0;
        this.notYetApprovedHoliday = this.monthlyAllocation.notYetApprovedHoliday || 0;
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style scoped>
	.error-border {
		border: 1px solid red;
	}

	tr.disable-allocation-row {
		opacity: 0.2;
	}

	tr.disable-allocation-row input {
		border: 0;
	}

	input[disabled] {
		background: #ffffff;
	}
	tr.closed-project-row {
		background: #fc5c6575;
	}
</style>
